module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Patch-0817c009d2fb39864ba7502a45c9949b.svg";